import { useState } from 'react';

import { useMaptilerScript } from '@spotahome/marketplace-common/src/utils/maptiler-script';

import InteractiveMap from './InteractiveMap.maptiler';

const InteractiveMapContainer = props => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  useMaptilerScript(() => setIsMapLoaded(true));

  return isMapLoaded ? <InteractiveMap {...props} /> : null;
};

export default InteractiveMapContainer;
